import React, { useState, useEffect } from "react";
import { Link,useParams } from "react-router-dom";
import { Form, Button, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Message from "../components/Message";
import Loader from "../components/Loader";
import { getUserDetails, updateUserProfile } from "../actions/userActions";
//import FormContainer from "../components/FormContainer";
import { useLocation, useNavigate } from "react-router-dom";
import { listMyOrders } from "../actions/orderActions";
import Paginate from "../components/Paginate";

// Format an ISO timestamp into a short, on-brand Spanish date like
// "15 abr 2025". Falls back to the original yyyy-mm-dd slice if the
// browser locale data isn't available — never crashes the row.
const formatOrderDate = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso.substring(0, 10);
    return d.toLocaleDateString("es-MX", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso.substring(0, 10);
  }
};

const ProfileScreen = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [ConfirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState(null);

  const { pageNumber } = useParams() || 1;

  const location = useLocation();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const userDetails = useSelector((state) => state.userDetails);
  const { loading, error, user } = userDetails;

  const orderListMy = useSelector((state) => state.orderListMy);
  const {
    loading: loadingOrders,
    error: errorOrders,
    orders,
    page,
    orderPages,
  } = orderListMy;

  const userUpdateProfile = useSelector((state) => state.userUpdateProfile);
  const { success } = userUpdateProfile;

  useEffect(() => {
    if (!userInfo) {
      //console.log("no user info");
      navigate("/login");
    } else {
      if (!user.name) {
        dispatch(getUserDetails("profile"));
        dispatch(listMyOrders(pageNumber));
      } else {
        setName(user.name);
        setEmail(user.email);
      }
      //console.log("page number", pageNumber);
      //console.log("page", page);
      if(pageNumber != page && page != undefined && pageNumber != undefined ){
        //console.log("page number dispatch");
        dispatch(listMyOrders(pageNumber));
      }

    }
  }, [dispatch, navigate, userInfo, user, orders,pageNumber]);

  const submitHandler = (e) => {
    e.preventDefault();
    //DISPATCH REGISTER
    if (password !== ConfirmPassword) {
      setMessage("Las contraseñas no coinciden");
    } else {
      //DISPATCH UPDATE PROFILE
      dispatch(updateUserProfile({ id: user._id, name, email, password }));
    }
  };

  return (
    <Row>
      <Col md={3} sm={12}>
        <div className="hadacy-profile-form">
          <style>{`
            @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600&family=Jost:wght@200;300;400;500&display=swap');

            /* ─── HADACY · profile form ───
               Same palette as the orders panel so both columns read as
               one cohesive piece. Rounded cream inputs, tracked-uppercase
               labels, gold focus glow, pill-shaped CTA. */
            .hadacy-profile-form {
              --cream: #f5f0e8;
              --dark: #1a1410;
              --gold: #b8933a;
              --gold-light: #d4af6a;
              --muted: #7a6e62;
              --card-bg: #faf7f2;
              --recess: #efe7d8;
              font-family: "Jost", sans-serif;
            }
            .hadacy-profile-form__heading {
              font-family: "Cormorant Garamond", serif;
              font-weight: 400;
              letter-spacing: 0.04em;
              color: var(--dark);
              font-size: 1.7rem;
              margin: 0 0 1.1rem 0;
              position: relative;
              padding-bottom: 0.5rem;
            }
            .hadacy-profile-form__heading::after {
              content: "";
              position: absolute;
              left: 0;
              bottom: 0;
              width: 48px;
              height: 1px;
              background: var(--gold);
            }
            .hadacy-profile-form .form-group { margin-bottom: 1rem; }
            .hadacy-profile-form .form-label,
            .hadacy-profile-form label {
              display: block;
              font-size: 0.62rem;
              letter-spacing: 0.22em;
              text-transform: uppercase;
              color: var(--muted) !important;
              font-weight: 400;
              margin-bottom: 0.4rem;
            }
            .hadacy-profile-form .form-control {
              background: var(--card-bg) !important;
              border: 1px solid rgba(184, 147, 58, 0.22) !important;
              border-radius: 10px !important;
              padding: 0.65rem 0.95rem !important;
              font-family: "Jost", sans-serif;
              font-size: 0.92rem;
              color: var(--dark) !important;
              box-shadow: none !important;
              transition: border-color .2s ease, box-shadow .2s ease,
                          background .2s ease;
            }
            .hadacy-profile-form .form-control:focus {
              border-color: var(--gold) !important;
              background: #fff !important;
              box-shadow: 0 0 0 3px rgba(184, 147, 58, 0.14) !important;
            }
            .hadacy-profile-form .form-control::placeholder {
              color: var(--muted);
              font-style: italic;
              opacity: 0.85;
            }
            /* Locked field (email) — keep it readable but signal it's
               not editable: muted background, slightly faded text, and
               the not-allowed cursor on hover. */
            .hadacy-profile-form .form-control.hadacy-profile-form__locked,
            .hadacy-profile-form .form-control.hadacy-profile-form__locked:focus {
              background: var(--recess) !important;
              color: var(--muted) !important;
              cursor: not-allowed !important;
              opacity: 1;
              border-color: rgba(184, 147, 58, 0.18) !important;
              box-shadow: none !important;
            }
            /* Pill CTA — same shape as orders "Ver detalles" + the search
               button site-wide. Replaces the default Bootstrap btn-primary. */
            .hadacy-profile-form__cta {
              display: inline-flex;
              align-items: center;
              gap: 0.55rem;
              padding: 0.7rem 1.5rem;
              border-radius: 999px !important;
              background: var(--dark) !important;
              border: 1px solid var(--dark) !important;
              color: var(--gold-light) !important;
              font-family: "Jost", sans-serif;
              font-size: 0.7rem;
              font-weight: 400;
              letter-spacing: 0.2em;
              text-transform: uppercase;
              margin-top: 0.4rem;
              transition: background .2s ease, color .2s ease, border-color .2s ease;
            }
            .hadacy-profile-form__cta:hover,
            .hadacy-profile-form__cta:focus {
              background: var(--gold) !important;
              border-color: var(--gold) !important;
              color: var(--dark) !important;
              box-shadow: none !important;
            }
            .hadacy-profile-form__cta i {
              font-size: 0.7rem;
            }
          `}</style>

          <h2 className="hadacy-profile-form__heading">Mi Perfil</h2>
          {message && <Message variant="danger">{message}</Message>}
          {error && <Message variant="danger">{error}</Message>}
          {success && <Message variant="success">Perfil actualizado</Message>}
          {loading && <Loader></Loader>}
          <Form onSubmit={submitHandler}>
            <Form.Group controlId="name">
              <Form.Label>Nombre</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ingresa tu nombre"
                value={name}
                onChange={(e) => setName(e.target.value)}
              ></Form.Control>
            </Form.Group>
            <Form.Group controlId="email">
              <Form.Label>Correo electrónico</Form.Label>
              {/* Email is the account anchor — locked so users can't
                  silently change it from this form. They can still see
                  it (helpful as a sanity check). */}
              <Form.Control
                type="email"
                value={email}
                readOnly
                disabled
                className="hadacy-profile-form__locked"
                title="No es posible cambiar el correo electrónico"
              ></Form.Control>
            </Form.Group>
            <Form.Group controlId="password">
              <Form.Label>Contraseña</Form.Label>
              <Form.Control
                type="password"
                placeholder="Nueva contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              ></Form.Control>
            </Form.Group>
            <Form.Group controlId="confirmPassword">
              <Form.Label>Confirmar contraseña</Form.Label>
              <Form.Control
                type="password"
                placeholder="Repite la contraseña"
                value={ConfirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              ></Form.Control>
            </Form.Group>
            <Button type="submit" className="hadacy-profile-form__cta">
              Actualizar
              <i className="fas fa-arrow-right"></i>
            </Button>
          </Form>
        </div>
      </Col>
      <Col md={9} sm={12}>
        <div className="hadacy-orders">
          <style>{`
            @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600&family=Jost:wght@200;300;400;500&display=swap');

            /* ─── HADACY · profile orders panel ───
               Cards instead of a table: each pedido reads as a quiet,
               editorial summary — date, ID and total in the head, payment
               and delivery as elegant pills, a single CTA to drill in.
               Variables are the same ones the rest of the site uses, so
               dark-mode.css can flip everything from one place. */
            .hadacy-orders {
              --cream: #f5f0e8;
              --dark: #1a1410;
              --gold: #b8933a;
              --gold-light: #d4af6a;
              --muted: #7a6e62;
              --card-bg: #faf7f2;
              --recess: #efe7d8;
              font-family: "Jost", sans-serif;
            }

            /* Section heading — serif, with a hairline gold rule under it
               so it matches the section dividers used elsewhere. */
            .hadacy-orders-heading {
              font-family: "Cormorant Garamond", serif;
              font-weight: 400;
              letter-spacing: 0.04em;
              color: var(--dark);
              font-size: 1.7rem;
              margin: 0 0 1.1rem 0;
              position: relative;
              padding-bottom: 0.5rem;
            }
            .hadacy-orders-heading::after {
              content: "";
              position: absolute;
              left: 0;
              bottom: 0;
              width: 48px;
              height: 1px;
              background: var(--gold);
            }

            .hadacy-orders-list {
              display: flex;
              flex-direction: column;
              gap: 0.9rem;
            }

            /* Each pedido is a 2-column grid: the head spans both rows,
               status pills sit bottom-left, CTA bottom-right. */
            .hadacy-orders-card {
              background: var(--card-bg);
              border: 1px solid rgba(184, 147, 58, 0.18);
              border-radius: 14px;
              padding: 1.1rem 1.25rem;
              display: grid;
              grid-template-columns: 1fr auto;
              gap: 0.9rem 1.25rem;
              align-items: center;
              transition: border-color .2s ease, box-shadow .2s ease,
                          transform .2s ease;
            }
            .hadacy-orders-card:hover {
              border-color: rgba(184, 147, 58, 0.45);
              box-shadow: 0 10px 24px rgba(26, 20, 16, 0.08);
              transform: translateY(-1px);
            }

            /* Card head — date / id / total side-by-side, with a hairline
               separator underneath. Wraps on mobile. */
            .hadacy-orders-card__head {
              grid-column: 1 / -1;
              display: flex;
              flex-wrap: wrap;
              gap: 0.9rem 2.4rem;
              padding-bottom: 0.85rem;
              border-bottom: 1px solid rgba(184, 147, 58, 0.14);
            }
            .hadacy-orders-card__head > div {
              display: flex;
              flex-direction: column;
              gap: 0.15rem;
              min-width: 0;
            }
            .ho-label {
              font-size: 0.62rem;
              letter-spacing: 0.22em;
              text-transform: uppercase;
              color: var(--muted);
              font-weight: 400;
            }
            .ho-date {
              font-family: "Cormorant Garamond", serif;
              font-size: 1.15rem;
              color: var(--dark);
              letter-spacing: 0.01em;
              text-transform: capitalize;
            }
            .ho-id {
              font-family: "Jost", sans-serif;
              font-size: 0.86rem;
              color: var(--dark);
              letter-spacing: 0.06em;
            }
            .ho-total {
              font-family: "Cormorant Garamond", serif;
              font-size: 1.3rem;
              color: var(--gold);
              letter-spacing: 0.02em;
            }

            /* Status row — payment + delivery pills */
            .hadacy-orders-card__status {
              grid-column: 1;
              display: flex;
              flex-wrap: wrap;
              gap: 0.55rem 0.7rem;
            }
            .ho-pill {
              display: inline-flex;
              align-items: center;
              gap: 0.6rem;
              padding: 0.45rem 0.95rem 0.45rem 0.75rem;
              border-radius: 999px;
              border: 1px solid;
              font-size: 0.78rem;
              line-height: 1.1;
            }
            .ho-pill > div {
              display: flex;
              flex-direction: column;
              line-height: 1.15;
            }
            .ho-pill-label {
              font-size: 0.58rem;
              letter-spacing: 0.18em;
              text-transform: uppercase;
            }
            .ho-pill-value {
              font-size: 0.82rem;
              letter-spacing: 0.02em;
              text-transform: capitalize;
            }
            .ho-pill i { font-size: 0.95rem; }

            /* Completed states wear gold; pending states stay quiet in
               cream/khaki so the eye lands on the action items first. */
            .ho-pill--ok {
              background: rgba(184, 147, 58, 0.10);
              border-color: rgba(184, 147, 58, 0.45);
              color: var(--gold);
            }
            .ho-pill--ok .ho-pill-label { color: var(--gold); opacity: 0.85; }
            .ho-pill--ok .ho-pill-value { color: var(--dark); }
            .ho-pill--pending {
              background: var(--recess);
              border-color: rgba(122, 110, 98, 0.32);
              color: var(--muted);
            }
            .ho-pill--pending .ho-pill-label { color: var(--muted); }
            .ho-pill--pending .ho-pill-value { color: var(--dark); }

            /* CTA — same shape as the search button & hero CTAs site-wide */
            .hadacy-orders-card__cta {
              grid-column: 2;
              justify-self: end;
              display: inline-flex;
              align-items: center;
              gap: 0.55rem;
              padding: 0.6rem 1.2rem;
              border-radius: 999px;
              background: var(--dark);
              color: var(--gold-light) !important;
              font-size: 0.68rem;
              letter-spacing: 0.2em;
              text-transform: uppercase;
              text-decoration: none !important;
              white-space: nowrap;
              transition: background .2s ease, color .2s ease;
            }
            .hadacy-orders-card__cta:hover {
              background: var(--gold);
              color: var(--dark) !important;
            }
            .hadacy-orders-card__cta i {
              font-size: 0.7rem;
              transition: transform .2s ease;
            }
            .hadacy-orders-card__cta:hover i { transform: translateX(3px); }

            /* Empty state — same card silhouette so the page doesn't
               feel like a void when there are no pedidos yet. */
            .hadacy-orders-empty {
              background: var(--card-bg);
              border: 1px solid rgba(184, 147, 58, 0.18);
              border-radius: 14px;
              padding: 2.5rem 1.5rem;
              text-align: center;
              color: var(--muted);
            }
            .hadacy-orders-empty i {
              font-size: 2rem;
              color: var(--gold);
              opacity: 0.6;
              margin-bottom: 0.9rem;
            }
            .hadacy-orders-empty h3 {
              font-family: "Cormorant Garamond", serif;
              font-weight: 400;
              font-size: 1.4rem;
              color: var(--dark);
              margin: 0 0 0.3rem 0;
            }
            .hadacy-orders-empty p {
              font-size: 0.88rem;
              margin: 0 0 1.2rem 0;
            }
            .hadacy-orders-empty-cta {
              display: inline-block;
              padding: 0.65rem 1.4rem;
              border-radius: 999px;
              background: var(--dark);
              color: var(--gold-light) !important;
              font-size: 0.68rem;
              letter-spacing: 0.2em;
              text-transform: uppercase;
              text-decoration: none !important;
              transition: background .2s ease, color .2s ease;
            }
            .hadacy-orders-empty-cta:hover {
              background: var(--gold);
              color: var(--dark) !important;
            }

            /* Mobile: stack the CTA under the status pills so nothing
               crowds the right edge on narrow screens. */
            @media (max-width: 575.98px) {
              .hadacy-orders-card { grid-template-columns: 1fr; }
              .hadacy-orders-card__cta {
                grid-column: 1;
                justify-self: stretch;
                justify-content: center;
              }
            }
          `}</style>

          <h2 className="hadacy-orders-heading">Mis Pedidos</h2>

          {loadingOrders ? (
            <Loader />
          ) : errorOrders ? (
            <Message variant="danger">{errorOrders}</Message>
          ) : !orders || orders.length === 0 ? (
            <div className="hadacy-orders-empty">
              <i className="fas fa-shopping-bag"></i>
              <h3>Aún no tienes pedidos</h3>
              <p>Cuando hagas tu primera compra, aparecerá aquí.</p>
              <Link to="/" className="hadacy-orders-empty-cta">
                Ir a la tienda
              </Link>
            </div>
          ) : (
            <>
              <div className="hadacy-orders-list">
                {orders.map((order) => (
                  <article key={order._id} className="hadacy-orders-card">
                    <div className="hadacy-orders-card__head">
                      <div>
                        <span className="ho-label">Pedido</span>
                        <span className="ho-date">
                          {formatOrderDate(order.createdAt)}
                        </span>
                      </div>
                      <div>
                        <span className="ho-label">ID</span>
                        <span className="ho-id">
                          #{order._id.slice(-8).toUpperCase()}
                        </span>
                      </div>
                      <div>
                        <span className="ho-label">Total</span>
                        <span className="ho-total">${order.totalPrice}</span>
                      </div>
                    </div>

                    <div className="hadacy-orders-card__status">
                      <div
                        className={`ho-pill ${
                          order.isPaid ? "ho-pill--ok" : "ho-pill--pending"
                        }`}
                      >
                        <i
                          className={
                            order.isPaid
                              ? "fas fa-check-circle"
                              : "far fa-clock"
                          }
                        ></i>
                        <div>
                          <span className="ho-pill-label">Pago</span>
                          <span className="ho-pill-value">
                            {order.isPaid
                              ? formatOrderDate(order.paidAt)
                              : "Pendiente"}
                          </span>
                        </div>
                      </div>

                      <div
                        className={`ho-pill ${
                          order.isDelivered
                            ? "ho-pill--ok"
                            : "ho-pill--pending"
                        }`}
                      >
                        <i
                          className={
                            order.isDelivered
                              ? "fas fa-check-circle"
                              : "fas fa-truck"
                          }
                        ></i>
                        <div>
                          <span className="ho-pill-label">Entrega</span>
                          <span className="ho-pill-value">
                            {order.isDelivered
                              ? formatOrderDate(order.deliveredAt)
                              : "En camino"}
                          </span>
                        </div>
                      </div>
                    </div>

                    <Link
                      to={`/order/${order._id}`}
                      className="hadacy-orders-card__cta"
                    >
                      Ver detalles
                      <i className="fas fa-arrow-right"></i>
                    </Link>
                  </article>
                ))}
              </div>
              <Paginate
                pages={orderPages}
                page={page}
                isOrderProfile={true}
              ></Paginate>
            </>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default ProfileScreen;
